import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[globalpopup-append]',
})
export class GlobalPopupAppendDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}




// WEBPACK FOOTER //
// ./src/app/shared/directives/globalPopupAppend.directive.ts